module.exports = __webpack_public_path__ + "static/media/chess.c4142da1.jpeg";